import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';
import styles from './styles.module.scss';

export type FiltersIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const FiltersIllustration = ({ ...props }: FiltersIllustrationProps) => (
  <BaseIllustration
    width="64"
    height="64"
    viewBox="0 0 64 64"
    stroke="none"
    className={styles.filtersIllustration}
    title="Filter Illustration"
    desc="A small illustration representing the concept of filtering"
    {...props}
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8C0 7.44772 0.447715 7 1 7L11 7C11.5523 7 12 7.44772 12 8C12 8.55228 11.5523 9 11 9L1 9C0.447715 9 0 8.55228 0 8ZM22 8C22 7.44772 22.4477 7 23 7L47 7C47.5523 7 48 7.44772 48 8C48 8.55228 47.5523 9 47 9L23 9C22.4477 9 22 8.55228 22 8Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 4C14.7909 4 13 5.79086 13 8C13 10.2091 14.7909 12 17 12C19.2091 12 21 10.2091 21 8C21 5.79086 19.2091 4 17 4ZM9 8C9 3.58172 12.5817 0 17 0C21.4183 0 25 3.58172 25 8C25 12.4183 21.4183 16 17 16C12.5817 16 9 12.4183 9 8Z"
      />
      <path d="M34 8C34 9.10457 33.1046 10 32 10C30.8954 10 30 9.10457 30 8C30 6.89543 30.8954 6 32 6C33.1046 6 34 6.89543 34 8Z" />
      <path d="M49 8C49 9.10457 48.1046 10 47 10C45.8954 10 45 9.10457 45 8C45 6.89543 45.8954 6 47 6C48.1046 6 49 6.89543 49 8Z" />
    </g>
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 32C1 31.4477 1.44772 31 2 31L26 31C26.5523 31 27 31.4477 27 32C27 32.5523 26.5523 33 26 33L2 33C1.44772 33 1 32.5523 1 32ZM37 32C37 31.4477 37.4477 31 38 31L62 31C62.5523 31 63 31.4477 63 32C63 32.5523 62.5523 33 62 33L38 33C37.4477 33 37 32.5523 37 32Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 28C29.7909 28 28 29.7909 28 32C28 34.2091 29.7909 36 32 36C34.2091 36 36 34.2091 36 32C36 29.7909 34.2091 28 32 28ZM24 32C24 27.5817 27.5817 24 32 24C36.4183 24 40 27.5817 40 32C40 36.4183 36.4183 40 32 40C27.5817 40 24 36.4183 24 32Z"
      />
      <path d="M19 56C19 57.1046 18.1046 58 17 58C15.8954 58 15 57.1046 15 56C15 54.8954 15.8954 54 17 54C18.1046 54 19 54.8954 19 56Z" />
      <path d="M19 32C19 33.1046 18.1046 34 17 34C15.8954 34 15 33.1046 15 32C15 30.8954 15.8954 30 17 30C18.1046 30 19 30.8954 19 32Z" />
      <path d="M4 32C4 33.1046 3.10457 34 2 34C0.89543 34 0 33.1046 0 32C0 30.8954 0.89543 30 2 30C3.10457 30 4 30.8954 4 32Z" />
      <path d="M49 32C49 33.1046 48.1046 34 47 34C45.8954 34 45 33.1046 45 32C45 30.8954 45.8954 30 47 30C48.1046 30 49 30.8954 49 32Z" />
      <path d="M64 32C64 33.1046 63.1046 34 62 34C60.8954 34 60 33.1046 60 32C60 30.8954 60.8954 30 62 30C63.1046 30 64 30.8954 64 32Z" />
    </g>
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 56C16 55.4477 16.4477 55 17 55L41 55C41.5523 55 42 55.4477 42 56C42 56.5523 41.5523 57 41 57L17 57C16.4477 57 16 56.5523 16 56ZM52 56C52 55.4477 52.4477 55 53 55L63 55C63.5523 55 64 55.4477 64 56C64 56.5523 63.5523 57 63 57L53 57C52.4477 57 52 56.5523 52 56Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47 52C44.7909 52 43 53.7909 43 56C43 58.2091 44.7909 60 47 60C49.2091 60 51 58.2091 51 56C51 53.7909 49.2091 52 47 52ZM39 56C39 51.5817 42.5817 48 47 48C51.4183 48 55 51.5817 55 56C55 60.4183 51.4183 64 47 64C42.5817 64 39 60.4183 39 56Z"
      />
      <path d="M34 56C34 57.1046 33.1046 58 32 58C30.8954 58 30 57.1046 30 56C30 54.8954 30.8954 54 32 54C33.1046 54 34 54.8954 34 56Z" />
    </g>
  </BaseIllustration>
);
